import jhsfBookingsApi from '../apis/jhsfBookingsApi';

const deleteVenturesService = async (ventureId: string): Promise<void> => {
  await jhsfBookingsApi.delete(`/ventures/${ventureId}`);
};

export default deleteVenturesService;
